var map = {
	"./birzeit_logo.png": 85,
	"./cyberx_logo.png": 39,
	"./grids_logo.svg": 86,
	"./gsg_logo.svg": 87,
	"./iconnect_logo.png": 88,
	"./ishraq_logo.jpg": 40,
	"./ministry_logo.jpg": 89,
	"./profile_photo_white.jpg": 90,
	"./shufat_logo.jpg": 91,
	"./tamkeen_logo.png": 92,
	"./uad.png": 93
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;